import { render } from "./PortalLayout.vue?vue&type=template&id=2414503f"
import script from "./PortalLayout.vue?vue&type=script&lang=js"
export * from "./PortalLayout.vue?vue&type=script&lang=js"

import "./PortalLayout.vue?vue&type=style&index=0&id=2414503f&lang=scss"

import exportComponent from "/home/jb/dev/cambiatech/libreosteo/enterprise/libreosteoenterprise/loenterprise-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__